import React from "react";
import translate from "../../services/Translation/lang";
export default function PlaceYourBetsBanner() {
  return (
    <p className="place-your-bets-banner slider-text-big">
      {translate("place_your_bets")}
    </p>
  );
}
